import { Target, Clock, CheckCircle2, Plug, MessageSquareHeart } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const reasons = [
  {
    icon: Target,
    title: "Solo los datos que realmente necesitas",
    desc: "Sin información de relleno, sin filtros adicionales. Solo lo útil.",
  },
  {
    icon: Clock,
    title: "Ahorro de tiempo desde el día uno",
    desc: "Recibes la base lista para usar. Sin limpieza ni reestructuración.",
  },
  {
    icon: CheckCircle2,
    title: "Datos actualizados y verificados",
    desc: "Cada base pasa un control de calidad antes de la entrega.",
  },
  {
    icon: Plug,
    title: "Compatible con tus sistemas",
    desc: "Excel, CRM, Google Sheets, SQL — entregamos en el formato que uses.",
  },
  {
    icon: MessageSquareHeart,
    title: "Asesoría incluida",
    desc: "Si no sabes qué base necesitas, te ayudamos gratis a definirla.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="porque"
      data-testid={TESTIDS.whySection}
      className="relative py-24 lg:py-32"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[rgba(0,240,255,0.02)] to-transparent" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
            / 03 — Por qué nosotros
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight mb-5">
            ¿Por qué elegir una
            <br />
            base <span className="italic font-light text-[#00f0ff]">personalizada</span>?
          </h2>
          <p className="text-[#94a3b8] text-base leading-relaxed">
            Las bases genéricas pierden tiempo y oportunidades. Las nuestras
            están diseñadas exactamente para tu operación.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            const featured = i === 0;
            return (
              <div
                key={r.title}
                className={`glass-card p-7 ${
                  featured ? "md:col-span-2 lg:col-span-1 lg:row-span-2 bg-gradient-to-br from-[rgba(0,240,255,0.06)] to-transparent" : ""
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-[#040812] border border-[rgba(0,240,255,0.3)] flex items-center justify-center shrink-0">
                    <Icon className="text-[#00f0ff]" size={20} />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-white text-lg leading-tight mb-2">
                      {r.title}
                    </h3>
                    <p className="text-[14px] text-[#94a3b8] leading-relaxed">
                      {r.desc}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
